wbApp.controller('RequestConsentFromAllCtrl', ['$scope', '$http', '$q', '$modal', '$translate', '$filter', 'messageBoxSvc',
    'consentDefinitionSvc', 'consentSvc',
function ($scope, $http, $q, $modal, $translate, $filter, messageBoxSvc, consentDefinitionSvc, consentSvc) {

    $scope.isSaving = false;
    $scope.selectableConsents = [];

    var allConsents = consentDefinitionSvc.getAllAsync(false);
    allConsents.$promise.then(function (c) {
        _.forEach(c, function (consent) {
            if (consent.active) {
                $scope.selectableConsents.push({
                    selected: false,
                    consent: consent
                });
            }
        }) ;
    });

    $scope.detailIsUnchanged = function () {
        return !(_.filter($scope.selectableConsents, { 'selected': true })).length;
    }

    $scope.onConsentClick = function (consent) {
        consent.selected = !consent.selected;
    };

    $scope.onSaveClick = function (selectableConsents, informUsers) {
        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;
        var selectedConsentIDs = _.map(_.filter(selectableConsents, { 'selected': true }), 'consent.consentDefinitionID');
        var userIDs = _.map($scope.selectedUsers, 'userID');

        if (selectedConsentIDs.length && userIDs.length) {
            consentSvc.assignConsensts({
                informUsers: informUsers,
                consnetIDs: selectedConsentIDs,
                userIDs: userIDs
            }, function () {
                $scope.isSaving = false;
                $scope.$hide();
            }, function () {
                $scope.isSaving = false;
                $scope.$hide();
            });
        } else {
            $scope.isSaving = false;
            $scope.$hide();
        }
    }
    
}]);


